<template>
  <div class="header-bar">
    <el-row class="header-bar__container">
      <el-col :span="10">
        {{TLang('欢迎来到东方福利网','my')}}
        <template v-if="loginInfo.loginFlag">
          <a
            :href="accountURL"
            target="_self"
            class="header-bar__item header-bar__item_first"
          >{{ loginInfo.loginUserMobile }}</a>
          <a
            class="header-bar__item"
            @click="onLogout"
          >{{TLang('退出登录','my')}}</a>
        </template>
        <template v-else>
          <a
            :href="loginURL"
            target="_self"
            class="header-bar__item header-bar__item_first"
          >{{TLang('登录','my')}}</a>
          <a
            :href="registerURL"
            target="_self"
            class="header-bar__item"
          >{{TLang('注册','my')}}</a>
        </template>
      </el-col>
      <el-col
        :span="14"
        class="tr"
      >
        <a
          :href="mallURL"
          target="_self"
          class="header-bar__item header-bar__item_first"
        >{{TLang('商城首页','my')}}</a>
        <a
          :href="accountURL"
          target="_self"
          class="header-bar__item"
        >{{TLang('我的账户','my')}}</a>
        <a
          :href="cartURL"
          target="_self"
          class="header-bar__item"
        >
        <!-- 英文 -->
          <img
              v-if="CookiesOne==='en-US'"
              src="./imgs/cart.png"
              class="header-bar__cart"
              alt="Cart"
            />
            <!-- 中文 -->
          <img
            v-if="CookiesOne!=='en-US'"
            src="./imgs/cart.png"
            class="header-bar__cart"
            alt="购物车"
          />{{TLang('购物车','my')}}
        </a>
        <a
          :href="guideURL"
          target="_self"
          class="header-bar__item"
        >{{TLang('卡劵使用指南','my')}}</a>
        <a
          class="header-bar__item header-bar__service"
        >{{TLang('服务热线','my')}}{{tel}}</a>
        <a
          href="javascript:;"
          class="header-bar__item header-bar__wx"
        >
          {{TLang('微信版','my')}}
          <!-- 英文 -->
          <img
            v-if="CookiesOne==='en-US'"
            src="./imgs/qrcode.jpg"
            class="header-bar__qr"
            alt="DF Wechat official account"
          />
          <!-- 中文 -->
           <img
            v-if="CookiesOne!=='en-US'"
            src="./imgs/qrcode.jpg"
            class="header-bar__qr"
            alt=""
          />
          <span class="header-bar__popover">
            <img
              src="./imgs/qrcode.jpg"
              alt
            />
          </span>
        </a>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { removeCookie, cookieKeys, unionFlag } from './../../utils';
import cache from '@utils/cache';
import Cookies from 'js-cookie';
export default {
  data() {
    return {
      loginInfo: {},
      city: (Cookies.get('address') && JSON.parse(Cookies.get('address') || '{}').cityId) || '145',
      tel: unionFlag() ? '400-618-2999' : '400-003-1010',
      CookiesOne:Cookies.get('df_lang'),
    };
  },
  computed: {
    mallURL() {
      // 商城首页
      return `/mall?cty=${this.loginInfo.city}`;
    },
    loginURL() {
      // 登录链接
      return `${this.loginInfo.loginUrl}&returnUrl=${encodeURIComponent(
        window.location.href,
      )}`;
    },
    registerURL() {
      // 注册链接
      return `/user/register?city=${this.city}`;
    },
    accountURL() {
      // 我的账户链接
      return `/user/center?city=${this.city}`;
    },
    cartURL() {
      // 购物车链接
      return `/shop/shopping/cart?city=${this.city}`;
    },
    guideURL() {
      // 卡券使用指南链接
      return `/static/guide?city=${this.city}`;
    },
  },
  created() {
    // 获取登录信息
    this.getLoginStatus();
  },
  methods: {
    getLoginStatus() {
      this.apis.headerApi.getLoginStatus().then(res => {
        this.loginInfo = res;
        cache.session.set('loginInfo', res);
      });
    },
    onLogout() {
      let cookies = cookieKeys();
      let { hostname } = window.location;
      cookies.forEach(item =>
        removeCookie(item, '/', `${hostname.substr(hostname.indexOf('.'))}`),
      );
      cookies = cookieKeys();
      cookies.forEach(item => removeCookie(item, '/', `.${hostname}`));
      cookies.forEach(item => removeCookie(item, '/', `${hostname}`));
      cookies.forEach(item => {
        document.cookie=item+'=;expires=' + new Date(0).toUTCString()+"; path=/";
      })
      if(unionFlag() === 'chailesemanager'){
      // if(unionFlag() === 'bfd'){
        this.apis.headerApi.getLoginOut().then(res => {
          window.location.href = this.loginInfo.logoutUrl;
      });
      }
      window.location.href = this.loginInfo.logoutUrl;
    },
  },
};
</script>

<style lang="less" scoped>
.header-bar {
  position: relative;
  background-color: #fafafa;
  color: #828282;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  min-width: 1200px;
  z-index: 999;
  &:hover{
    cursor: pointer;
  }
  &__container {
    .wrapper();
  }
  &__item {
    color: #828282;
    cursor: pointer;
    &:before {
      content: "|";
      position: relative;
      top: -1px;
      color: #828282;
      opacity: 0.3;
      margin-left: 15px;
      margin-right: 15px;
    }
    &:hover {
      color: #619ee0;
    }
    &_first:before {
      display: none;
    }
  }
  &__service {
    cursor: default;
    &:hover {
      color: #828282;
    }
  }
  &__cart {
    position: relative;
    top: -2px;
    vertical-align: middle;
    width: 16px;
    margin-right: 2px;
  }
  &__wx {
    display: inline-block;
    color: rgb(0, 0, 225);
    &:hover {
      .header-bar__popover {
        display: block;
      }
    }
  }
  &__qr {
    position: relative;
    top: -2px;
    vertical-align: middle;
    width: 20px;
  }
  &__popover {
    position: absolute;
    display: none;
    top: 40px;
    right: 0;
    z-index: 9;
    width: 130px;
    background-color: #fff;
    box-shadow: 0 2px 6px #dcd7d7;
    &:before {
      content: "";
      position: absolute;
      display: block;
      top: -14px;
      left: 50%;
      margin-left: -7px;
      width: 0;
      height: 0;
      line-height: 0;
      font-size: 0;
      border-width: 7px;
      border-style: solid;
      border-color: transparent transparent #fff;
    }
  }
}
</style>
